
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlertheaderGroupIec as ObiAlertheaderGroupIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alertheader-group-iec.js';
 
 
 

 
 export const ObiAlertheaderGroupIec = createComponent({
   react: React,
   tagName: 'obi-alertheader-group-iec',
   elementClass: ObiAlertheaderGroupIecElement,
   events: {
     
   }
  });
 
 